import { render, staticRenderFns } from "./AgeConfirmModal.vue?vue&type=template&id=48b7e29f&"
import script from "./AgeConfirmModal.vue?vue&type=script&lang=js&"
export * from "./AgeConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports